<template>
  <el-row class="footer-row">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark">

        <div class="container">
          {{$t('FOOTER_COPY_RIGHT',{year:endYear, companyName: oemCompany.companyName && lang === 'zh'? oemCompany.companyName &&oemCompany.companyName['zh-cn']: oemCompany.companyName &&oemCompany.companyName[lang]})}}
          <a v-if="oemCompany.icp" href="https://beian.miit.gov.cn" class="to-beian" target="_blank">{{ oemCompany.icp }}</a>
            <a v-if="oemCompany.psb" target="_blank" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+oemCompany.psb"
             style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left: 8px;"><img src="@/assets/img/gongan.png" style="float:left;" />
            <span style="color:#939393;">沪公网安备 {{oemCompany.psb}}号</span>
          </a>
        </div>
      </div>
    </el-col>
    <scrollTop :scrollItems="$store.state.so.scrollItems">

    </scrollTop>
  </el-row>

</template>

<script>
  import {
    mapState
  } from 'vuex'
  import scrollTop from './../common/components/scrollTop.vue'
  export default {
    name: 'Footer',
    components: {
      scrollTop
    },
    data() {
      return {
        endYear: new Date().getFullYear()
      }
    },
    computed: {
      ...mapState(['lang', 'oemCompany']),
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer-row {
    font-size: 11px;
    text-align: center;
    height: 50px;
    line-height: 50px;
  }

  a.to-beian {
    color: #939393;
    margin-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue